import { useCallback, useEffect, useRef, useState } from "react";

import HiviewerLoader from "../HiviewerLoader";
import styles from "./WelcomeSplash.module.scss";

const LETTERS_COUNT = 8;
const LETTER_STEP_MS = 60;
const FADE_START_MS = LETTERS_COUNT * LETTER_STEP_MS + 800;
const FADE_MS = 600;
const MIN_VISIBLE_MS = 2000;

const WelcomeSplash = () => {
  const [isVisible, setIsVisible] = useState(true);
  const mountedAtRef = useRef(Date.now());
  const hideTimeoutRef = useRef<number>();

  const hideSplash = useCallback(() => {
    const elapsed = Date.now() - mountedAtRef.current;
    const remainingDelay = Math.max(MIN_VISIBLE_MS - elapsed, 0);

    window.clearTimeout(hideTimeoutRef.current);
    hideTimeoutRef.current = window.setTimeout(() => {
      setIsVisible(false);
    }, remainingDelay);
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    const timeout = window.setTimeout(hideSplash, FADE_START_MS + FADE_MS + 150);

    return () => {
      window.clearTimeout(timeout);
      window.clearTimeout(hideTimeoutRef.current);
    };
  }, [hideSplash, isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.splash} aria-label="Loading" role="status">
      <HiviewerLoader
        className={styles.logo}
        width={170}
        height="auto"
        color="#E01313"
        maxOpacity={1}
        fadeStartMs={FADE_START_MS}
        fadeMs={FADE_MS}
        repeat={false}
        onCycleEnd={hideSplash}
      />
    </div>
  );
};

export default WelcomeSplash;
